import { render, staticRenderFns } from "./legend-real.vue?vue&type=template&id=4507eb24&scoped=true&"
import script from "./legend-real.vue?vue&type=script&lang=js&"
export * from "./legend-real.vue?vue&type=script&lang=js&"
import style0 from "./legend-real.vue?vue&type=style&index=0&id=4507eb24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4507eb24",
  null
  
)

export default component.exports